<template>
  	<div class="bg-grey h-auto pt-8 pb-10">

		<div class="flex justify-center">
			<div class="w-5/6 bg-white shadow-lg rounded pb-4">
				<div class="w-full bg-green-light py-1 rounded-t"></div>
				<div class="w-full text-left px-4 pt-4">
					<p class="text-4xl font-light text w-full border-b pb-4">Inställningar</p>

					<div class="mt-5 pb-4">
						<GeneralSettings/>

					</div>

					<div class="mt-5 pb-4">
						<InterpolationSettings></InterpolationSettings>
					</div>
				</div>
			</div>
		</div>

  	</div>
</template>

<script>

import InterpolationSettings from '@/components/settings/InterpolationSettings.vue'
import GeneralSettings from '@/components/settings/GeneralSettings.vue'

export default {
	
	name: 'Settings',

	components: {
		InterpolationSettings,
		GeneralSettings,
	},

	mounted() {
		this.$store.dispatch("interpolationSettings/GET_INTERPOLATION_SETTINGS")
	}

}
</script>